export default __webpack_public_path__ + "static/media/dummy-image.05f4660f.webp";